import { useMemo } from 'react';
import { createApiClient } from '@shared/api/client/api-client';
import { createApiServices, type ApiServices } from '@shared/api/lib/services';

import { env } from '@shared/config/env';

export function useApiServices(): ApiServices {
  return useMemo(() => {
    const client = createApiClient({ baseURL: env.API_BASE_URL });
    return createApiServices(client);
  }, []);
}
